import { FC } from "react";
import Alert from "react-bootstrap/Alert";
import { ContactFieldsFragment, useContactsQuery } from "app/api/graph/types";
import { SelectData, SelectDataProps } from "app/component/form/select/SelectData";

type Props = SelectDataProps<ContactFieldsFragment>;

export const SelectContact: FC<Props> = ({ ...props }) => {
    const { data, loading, fetchMore, error } = useContactsQuery({
        notifyOnNetworkStatusChange: true,
    });

    if (error) {
        return <Alert variant="danger">{error.message}</Alert>;
    }

    return (
        <SelectData
            {...props}
            connection={data?.contacts}
            label={(value) => value.name ?? ""}
            isLoading={loading}
            onPaginate={() => fetchMore({ variables: { after: data?.contacts?.pageInfo?.endCursor } })}
        />
    );
};
